import { PLATFORM } from 'aurelia-framework';
import { IRoute, IRouteSettings } from '@shared/interfaces/interfaces';

export class Routes {

  public unknownRoute: IRoute = {
    route: ['blog/notfound'],
    name: 'notfound',
    settings: <IRouteSettings>
      {
        spa: 'blog',
      },
    moduleId: PLATFORM.moduleName('../pages/notfound/notfound', 'blog-async-notfound'),
    nav: false,
    title: 'Page not found',
  };

  public routeArray: IRoute[] = [
    <IRoute>{
      route: ['blog/home'],
      name: 'home',
      settings: <IRouteSettings>
        {
          spa: 'blog',
        },
      moduleId: PLATFORM.moduleName('../pages/home/home', 'blog-async-home'),
      nav: true,
      // title: 'Home',
    },
    <IRoute>
      {
        route: ['blog/post/:id/:groupurl/:resourceurl?'],
        name: 'post',
        settings: <IRouteSettings>
          {
            spa: 'blog',
          },
        moduleId: PLATFORM.moduleName('../pages/post/post', 'blog-async-post'),
        nav: false,
        // title: 'Blog Post',
      },
  ];
}
